import { create } from "zustand";

import { HubStatus } from "./hub-status";

export interface HubState {
  hubStatus: { [companyId: number]: HubStatus };
  setHubStatus: (companyId: number, status: HubStatus) => void;
}

export const useHubStore = create<HubState>()((set, get) => {
  return {
    hubStatus: {},
    setHubStatus: (companyId: number, status: HubStatus) => {
      const d = { ...get().hubStatus };
      d[companyId] = status;
      set(() => ({
        hubStatus: d,
      }));
    },
  };
});
